export default __webpack_public_path__ + "static/media/jolt-65-5.63cc7116.jpg";